import axios from "axios";

// Once username has been validated, display the password
// form, where users with passwords can be authenticated
// into the system.
function PasswordForm(props) {
    const handleSubmit = async (e) => {
        // Prevent default form submit behavior (page reload, etc.)
        e.preventDefault();

        // Ensure password exists before sending request to backend
        let password = document.getElementById("password-input").value;
        if (password === undefined || password === "") {
            props.setError({ "error": true, "error-msg": "Please provide a password and try again." })
            return;
        }

        // Authenticate with username and password
        await axios.post('/api/login',
            { 
                "email": props.validatedUsername,
                "password": password
            },
            { withCredentials: true, crossDomain: true }
        ).then((response) => {
            props.redirectToExplore();
        }).catch((error) => {
            props.setError({ "error": true, "error-msg": error.response.data.message });
        });
      };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <p className="label">Username</p>
                <p id="validated-username">{props.validatedUsername}</p>
            </div>
            <div>
                <label className="label" for="password-input">Password</label>
                <input type = "password" id="password-input" className = "login-credentials" name="password-input" />
            </div>
            <input type="submit" value="Login" id="login-button" />
        </form>
    )
}

export default PasswordForm;